<template>
  <div class="programmes-wrap">
    <!-- {{ugProgrammes}} -->
    <div class="block">
      <!-- <input v-model="searchTerm" type="text"> -->
      <!-- {{filteredProgrammes}} -->
      <search-filter :searchTerm.sync="searchTerm" 
       :studyDelivery.sync="studyDelivery"
      />

      <!-- <div v-if="filteredProgrammes.length === 0">
        <p>
          No results found for <strong>{{ searchTerm }}</strong
          >,
          <a
            :href="`https://www.wgtn.ac.nz/search-study?q=${searchTerm}&international=true&tab=subjects&filterToggle=f.Level+of+study%7Clevelstudy=postgraduate-programmes%26f.Level+of+study%7CFUNcm26z91x7rdxcjbk0tt2zym66=Postgraduate`"
            >search our subjects.</a
          >
        </p>
      </div> -->

      <div v-if="filteredProgrammes.length === 0 && searchTerm.length">
        <p>
          No results found for <strong>{{ searchTerm }}</strong
          >,
          <a
            :href="`https://www.wgtn.ac.nz/search-study?q=${searchTerm}&international=true&tab=subjects&filterToggle=f.Level+of+study%7Clevelstudy=postgraduate-programmes%26f.Level+of+study%7CFUNcm26z91x7rdxcjbk0tt2zym66=Postgraduate`"
            >search our subjects.</a
          >
        </p>
      </div>

      <div v-else-if="filteredProgrammes.length === 0">
        <p>No results found.</p>
      </div>

      <ugprogramme
        v-for="prog in filteredProgrammes"
        :key="prog.name"
        :prog="prog"
      />
    </div>
  </div>
</template>

<script>
import ugprogramme from "./UGProgramme.vue";
import searchFilter from "./SearchFilter.vue";

export default {
  name: "UgProgrammes",
  props: ["ugProgrammes"],
  components: {
    ugprogramme,
    searchFilter,
  },
  data() {
    return {
      searchTerm: "",
      studyDelivery: ""
    };
  },
  computed: {
    filteredProgrammes() {
      let filteredProgs = this.ugProgrammes.filter((prog) => {
        return prog.name.toLowerCase().includes(this.searchTerm.toLowerCase());
      });
      // let orderedStories = filteredStories.sort( ( a, b ) => {
      //   return b.upvoted - a.upvoted;
      // } )
      // return orderedStories;
      let alphabetisedProgs = filteredProgs.sort((a, b) => {
        return a.name.localeCompare(b.name);
      });

      if (this.studyDelivery == "Online study") {
        let deliveryFilter = alphabetisedProgs.filter((prog) => {
          return prog.intDistance === true;
        });

        alphabetisedProgs = deliveryFilter;
      }



      return alphabetisedProgs;
      // return filteredProgs;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>